
import { ModelContact } from '../../models/ModelContact';
import { CreatFieldComponent } from '../../components/Fields';
import { generateId } from '../../scripts/utils';

import { Box, Button, Typography } from '@mui/material';
import { useData } from '../../hooks/DataProvider';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import translations from '../../scripts/translations';


const ContactItem = ({ contact, setDataContact, dataTier, updateDataTier }) => {

    const { language } = useData();

    const btns = translations.button[language];


    const handelEdit = () => {
        setDataContact(contact);
    }

    const handelDelete = () => {
        const updatedContacts = dataTier.contacts.filter(c => c._id !== contact._id);
        updateDataTier({ contacts: updatedContacts });
    }

    async function setClipboard(text) {
        const type = "text/plain";
        const clipboardItemData = {
            [type]: text,
        };
        const clipboardItem = new ClipboardItem(clipboardItemData);
        await navigator.clipboard.write([clipboardItem]);
    }

    return (
        <Box key={contact._id} sx={{ border: '1px solid #ccc', padding: 2, marginBottom: 2, borderRadius: 1 }}>
            {(contact.firstName || contact.lastName) && <Typography variant="h6">{contact.firstName} {contact.lastName}</Typography>}
            {contact.email && <Box sx={{ display: 'flex', gap: 1 }} >
                <Typography variant="body1">email: {contact.email}</Typography>
                <ContentCopyIcon fontSize='small' onClick={() => setClipboard(contact.email)} />

            </Box>}
            {contact.phone && <Typography variant="body1">phone: {contact.phone}</Typography>}
            {contact.mobile && <Box sx={{ display: 'flex', gap: 1 }} > <Typography variant="body1">mobile: {contact.mobile}</Typography> <ContentCopyIcon /> </Box>}
            {contact.position && <Typography variant="body1">position: {contact.position}</Typography>}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', marginTop: 1 }}>
                {contact.isMain && <CreatFieldComponent field={ModelContact.isMain} data={contact} updateData={setDataContact} disabledInForm={true} />}
                {contact.isBilling && <CreatFieldComponent field={ModelContact.isBilling} data={contact} updateData={setDataContact} disabledInForm={true} />}
                {contact.isShipping && <CreatFieldComponent field={ModelContact.isShipping} data={contact} updateData={setDataContact} disabledInForm={true} />}
                {contact.isAccounting && <CreatFieldComponent field={ModelContact.isAccounting} data={contact} updateData={setDataContact} disabledInForm={true} />}
                {contact.isActiveContact && <CreatFieldComponent field={ModelContact.isActiveContact} data={contact} updateData={setDataContact} disabledInForm={true} />}
            </Box>

            <Box sx={{ display: 'flex', gap: 1, marginTop: 1, justifyContent: 'flex-end' }}>
                <Button variant="outlined" color="primary" onClick={handelEdit}>{btns.edit}</Button>
                <Button variant="outlined" color="secondary" onClick={handelDelete}>{btns.delete}</Button>
            </Box>
        </Box>
    );
}


const Contact = ({ dataTier, updateDataTier, dataContact, setDataContact }) => {

    const { language } = useData();

    const btns = translations.button[language];


    const handelNew = () => {
        if (dataTier?._id) {
            setDataContact({
                _id: generateId(),
                // tierId: dataTier._id,
                lastNameme: '',
                firstName: '',
                email: '',
                phone: '',
                mobile: '',
                position: '',
                isMain: false,
                isBilling: false,
                isShipping: false,
                isAccounting: false,
                isActiveContact: true

            })
        }
    }

    const handelUpdateDataTier = () => {

        let newContacts = dataTier.contacts.filter(c => c._id !== dataContact._id);
        newContacts.push(dataContact);
        // newContacts.sort((a, b) => a.lastName.localeCompare(b.lastName));
        updateDataTier({ ...dataTier, contacts: newContacts });
        setDataContact({});
    }

    return (
        <>
            {
                dataTier._id &&

                <>
                    <Box>
                        {
                            dataTier.contacts && dataTier.contacts.length > 0 ? (
                                dataTier.contacts.map((contact) => {
                                    return (
                                        <ContactItem key={contact._id}
                                            contact={contact}
                                            setDataContact={setDataContact}
                                            dataTier={dataTier}
                                            updateDataTier={updateDataTier}
                                        />
                                    );
                                })) : ''
                        }
                    </Box>

                    <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>

                        {dataContact._id ?
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handelUpdateDataTier}
                            >
                                {btns.save}
                            </Button>
                            :
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handelNew}
                            >
                                {btns.newContact}
                            </Button>
                        }

                    </Box>


                    {dataContact._id &&
                        <Box sx={{ marginTop: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <CreatFieldComponent field={ModelContact.lastName} data={dataContact} updateData={setDataContact} />
                            <CreatFieldComponent field={ModelContact.firstName} data={dataContact} updateData={setDataContact} />
                            <CreatFieldComponent field={ModelContact.email} data={dataContact} updateData={setDataContact} />
                            <CreatFieldComponent field={ModelContact.phone} data={dataContact} updateData={setDataContact} />
                            <CreatFieldComponent field={ModelContact.mobile} data={dataContact} updateData={setDataContact} />
                            <CreatFieldComponent field={ModelContact.position} data={dataContact} updateData={setDataContact} />
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                <CreatFieldComponent field={ModelContact.isMain} data={dataContact} updateData={setDataContact} />
                                <CreatFieldComponent field={ModelContact.isBilling} data={dataContact} updateData={setDataContact} />
                                <CreatFieldComponent field={ModelContact.isShipping} data={dataContact} updateData={setDataContact} />
                                <CreatFieldComponent field={ModelContact.isAccounting} data={dataContact} updateData={setDataContact} />
                                <CreatFieldComponent field={ModelContact.isActiveContact} data={dataContact} updateData={setDataContact} />
                            </Box>
                        </Box>}
                </>
            }
        </>
    );
}

export default Contact;
